export default "__VITE_ASSET__B$TpZrzj__"